export default {
  namespaced: true,
  state: {
    values: [],
  },
  mutations: {
    SET(state, objects) {
      state.values = objects;
    },
  },
  getters: {
    all: (state) => Object.values(state.values || {}).map((object) => ({
      measuring: ['melo', 'malo'].includes(object.type) ? 'rlm' : 'slp',
      ...object,
    })),
    byUuid: (state, getters) => (uuid) => getters.all.find((object) => object.uuid === uuid),
    rlm: (state) => Object.values(state.values || {}).filter((object) => ['rlm', 'melo', 'malo'].includes(object.additional?.type || object.type)),
    hasRlm: (state, getters) => getters.rlm.length > 0,
    hasMultipleRlm: (state, getters) => getters.rlm.length > 1,
    slp: (state) => Object.values(state.values || {}).filter((object) => (object.additional?.type || object.measuring) === 'slp' || object.additional?.type === 'ims'),
    hasSlp: (state, getters) => getters.slp.length > 0,
    hasMultipleSlp: (state, getters) => getters.slp.length > 1,
    byEnergyType: (state, getters, rootState) => {
      const objectsByEnergyType = {};

      Object.keys(rootState.centerUsageChart.supportedEnergyTypes).forEach((energyType) => {
        objectsByEnergyType[energyType] = getters.all.filter((object) => object.energyType === energyType);
      });

      return objectsByEnergyType;
    },
    hasForEnergyType: (state, getters) => (energyType) => (getters.byEnergyType[energyType] || []).length > 0,
    idByUuid: (state, getters) => (uuid) => getters.all.find((o) => o.uuid === uuid)?.objectId || null,
    uuidByObjectId: (state, getters) => (id) => getters.all.find((o) => o.objectId === id)?.uuid || id,
    aliasByUuid: (state, getters) => (uuid) => getters.all.find((o) => o.uuid === uuid)?.alias || null,
    typeByUuid: (state, getters) => (uuid) => getters.all.find((o) => o.uuid === uuid)?.type || null,
    energyTypeByUuid: (state, getters) => (uuid) => getters.all.find((o) => o.uuid === uuid)?.energyType || null,
    getByMeasuringType: (state, getters) => (measuringType) => getters.all.filter((object) => {
      const typeToCheck = measuringType === 'rlm' ? ['rlm', 'melo', 'malo'] : measuringType;

      if (Array.isArray(typeToCheck)) {
        return typeToCheck.includes(object.additional?.type || object.type);
      }

      return (object.additional?.type || object.type) === typeToCheck;
    }),
    hasOfMeasuringType: (state, getters) => (measuringType) => getters.getByMeasuringType(measuringType).length > 0,
    hasMultipleOfMeasuringType: (state, getters) => (measuringType) => getters.getByMeasuringType(measuringType).length > 1,
    getByEnergyTypeAndMeasuring: (state, getters) => (energyType, measuringType) => (getters.byEnergyType[energyType] || []).filter((object) => {
      const typeToCheck = measuringType === 'rlm' ? ['rlm', 'melo', 'malo'] : measuringType;

      if (Array.isArray(typeToCheck)) {
        return typeToCheck.includes(object.additional?.type || object.measuring);
      }

      return (object.additional?.type || object.measuring) === typeToCheck;
    }),
    hasForEnergyTypeAndMeasuring: (state, getters) => (energyType, measuringType) => getters.getByEnergyTypeAndMeasuring(energyType, measuringType).length > 0,
    hasMultipleEnergyTypesForMeasuringType: (state, getters) => (measuringType) => {
      const energyTypes = [];

      getters.getByMeasuringType(measuringType).forEach((object) => {
        if (!energyTypes.includes(object.energyType)) {
          energyTypes.push(object.energyTypes);
        }
      });

      return energyTypes.length > 1;
    },
  },
};
